/**
 * создает урл
 * @param url - строка с адресом
 * @param params - объект параметров
 */
export function createUrl(
  url: string,
  params: Dictionary<string | number> = {},
): URL {
  const fullUrl = new URL(url)

  for (const key in params) {
    if (params[key]) {
      fullUrl.searchParams.set(key, params[key].toString())
    }
  }

  return fullUrl
}
